module.exports = __webpack_public_path__ + "static/media/CIAP-04-zoomed.e5538b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/Zoomed/CIAP-04-zoomed.jpg
// module id = 728
// module chunks = 0